// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3kHsl","noInteraction":"EventWrapper_noInteraction__u4lvT"};